module.exports = "/**\r\n * Paste or drop some CSS here and explore\r\n * the syntax tree created by chosen parser.\r\n * Enjoy!\r\n */\r\n\r\n@media screen and (min-width: 480px) {\r\n    body {\r\n        background-color: lightgreen;\r\n    }\r\n}\r\n\r\n#main {\r\n    border: 1px solid black;\r\n}\r\n\r\nul li {\r\n\tpadding: 5px;\r\n}\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/parsers/css/codeExample.txt
 ** module id = ./src/parsers/css/codeExample.txt
 ** module chunks = 0
 **/